export const AUTOSUGGEST_CLEAR = 'waitrose/search/AUTOSUGGEST_CLEAR';
export const AUTOSUGGEST_FULFILLED = 'waitrose/search/AUTOSUGGEST_FULFILLED';
export const AUTOSUGGEST_PENDING = 'waitrose/search/AUTOSUGGEST_PENDING';
export const AUTOSUGGEST_REJECTED = 'waitrose/search/AUTOSUGGEST_REJECTED';
